<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <breadcrumb :routerList="[{to:'/xietongguanli/newManagement',title:'协同管理'},{title:'协同问题详情'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail35">
                                        <el-form :model="bh" label-position="right" ref="bh" :inline="true"
                                                 class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="客户类型" class="h-elformWrap-2" prop="euType">
                                                <el-input v-model="bh.euType" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="客户名称" class="h-elformWrap-2" prop="euName">
                                                <el-input v-model="bh.euName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode">
                                                <el-input v-model="bh.areaCode" readonly></el-input>
                                            </el-form-item>
                                            <!--<el-form-item label="部门/科室" class="h-elformWrap-2" prop="department">
                                                <el-input v-model="bh.department" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                                                <el-input v-model="bh.contactuserName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                                                <el-input v-model="bh.telephone" readonly></el-input>
                                            </el-form-item>-->
                                            <el-form-item label="链群" class="h-elformWrap-2" prop="lianqunName">
                                                <el-input v-model="bh.lianqunName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="要求到位时间" class="h-elformWrap-2" prop="endDate" value-format="yyyy-MM-dd HH:mm:ss">
                                                <el-input v-model="bh.endDate" readonly></el-input>
                                            </el-form-item>
<!--                                            <el-form-item label="答复到位时间" class="h-elformWrap-2" prop="requireTime" value-format="yyyy-MM-dd HH:mm:ss">
                                                <el-input v-model="bh.requireTime" :disabled="isCucode"></el-input>
                                            </el-form-item>-->
                                            <el-form-item label="答复到位时间" class="h-elformWrap-2" prop="requireDate">
                                                <el-date-picker
                                                        v-model="requireDate"
                                                        type="date"
                                                        placeholder="选择日期">
                                                </el-date-picker>
                                            </el-form-item>

                                          <el-form-item label="问题分类" class="h-elformWrap-2" prop="problemType">
                                            <el-input  v-model="bh.problemTypeName"  readonly></el-input>
                                          </el-form-item>

                                          <el-form-item label="需求类型" class="h-elformWrap-2" prop="problemDeptTypeName">
                                            <el-input  v-model="bh.problemDeptTypeName"  readonly></el-input>
                                          </el-form-item>

                                          <el-form-item label="提报人" class="h-elformWrap-2" prop="problemDeptTypeName">
                                            <el-input  v-model="bh.cuname"  readonly></el-input>
                                          </el-form-item>

                                            <el-form-item label="协同问题" class="h-elformWrap-1 ljjtexts" prop="pain">
                                                <div style="width: 100%;border-bottom: 1px solid #dedede;color: #868686;word-break:break-all;padding-left: 0.15rem;">{{bh.dailyQuestion}}</div>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                            <!-- 资源闭环对话 -->
                            <div class="y-container">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                  <h1>要求答复人</h1>
                                </div>
                                <div class="y_tabBar">
                                    <div class="eveBar" :class="{eveBarAc:index1 == acIndex}"
                                         v-for="(item1 , index1) in deptList" :key="index1+1"
                                         @click="tabchange(index1)">
                                        {{item1.jobGroup}}-{{item1.jobUsername}}
                                        <img
                                                :src="index1 == acIndex?imgcheck.checkblueAc:imgcheck.checkblue"
                                                v-if="item1.isLoop == 1" class="imgrigt">
                                        <div class="redCircle"
                                             v-if="(item1.count % 2 == 1  && item1.cucode == userCode && item1.isLoop==0) || (item1.count % 2 == 0  && item1.jobUsercode == userCode && item1.isLoop==0) "></div>
                                    </div>
                                </div>
                                <div class="containGrey">
                                    <div class="containAll" v-if="index1 == acIndex"
                                         v-for="(item1 , index1) in deptList" :key="index1+2">
                                        <div class="dialogDiv" v-for="(item2,index2) in item1.repList" :key="index2">
                                            <div class="timeTip">{{item2.cdate}}</div>
                                            <div class="firstTalk" :class="{firstTalk2:item2.cucode ==userCode}">
                                                <div class="leftname">{{item2.cuname}}</div>
                                                <div class="containTalk"
                                                     :class="{containTalk2:item2.cucode ==userCode}">
                                                    {{item2.repContent}}
                                                </div>
                                            </div>
                                          <div class="h-formBox" style="margin-top:15px" v-if="index2 == 0">
                                            <el-form :model="q" label-position="right" ref="zy" :inline="true"
                                                     :rules="rules"
                                                     class="demo-form-inline h-formBorder">
                                              <div >
                                                <el-form-item label="需求类型" class="h-elformWrap-1" prop="differenceType" style="margin-left: 60px">
                                                  <el-select v-model="q.differenceType" :v="q.differenceType"
                                                             @change="changDealer($event)"
                                                             placeholder="请选择"
                                                             style="width: 250px;"
                                                             disabled
                                                  >
                                                    <el-option label="个性问题" value="1"></el-option>
                                                    <el-option label="共性问题" value="2"></el-option>
                                                  </el-select>
                                                </el-form-item>
                                                <el-form-item label="根治措施" class="h-elformWrap-1" prop="areaProblem" v-if="q.differenceType==2">
                                                  <el-input  type="textarea" style="width: 450px;" :rows="1"  v-model="q.areaProblem" :show-overflow-tooltip="true" disabled></el-input>
                                                </el-form-item>
                                              </div>

                                              <el-form-item label="到位时间" class="h-elformWrap-1" prop="inPlaceDate" v-if="q.differenceType==2" style="margin-left: 60px;margin-top: 8px">
                                                <el-date-picker
                                                    v-model="q.inPlaceDate"
                                                    :picker-options="pickerOptions"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    style="width: 250px;"
                                                    disabled
                                                    placeholder="选择日期">
                                                </el-date-picker>
                                              </el-form-item>
                                              <el-form-item label="解决进度" class="h-elformWrap-1" prop="measureProblem" v-if="q.differenceType==2" style="margin-top: 8px">
                                                <el-input  type="textarea" style="width: 450px;" :rows="1"  v-model="q.measureProblem" :show-overflow-tooltip="true" disabled></el-input>
                                              </el-form-item>


                                            </el-form>
                                          </div>
                                        </div>
                                    </div>
                                    <div class="replyBox"
                                         v-if="index1 == acIndex  && isGx == 0  && ((userCode == item1.cucode && item1.count % 2 ==1)
                                         || (userCode == item1.jobUsercode && item1.count % 2 ==0))
                                         "
                                         v-for="(item1 , index1) in deptList" :key="index1+4">
                                        <div class="h-formBox" style="Margin:10px">
                                          <el-form :model="q" label-position="right" ref="zy" :inline="true"
                                                   :rules="rules"
                                                   class="demo-form-inline h-formBorder">
                                    <div>
                                            <el-form-item label="需求类型" class="h-elformWrap-1" prop="differenceType" style="margin-left: 60px">
                                              <el-select v-model="q.differenceType" :v="q.differenceType"
                                                         @change="changDealer($event)"
                                                         placeholder="请选择"
                                                         style="width: 250px;"
                                                         :disabled="item1.isLoop == 1"
                                              >
                                                <el-option label="个性问题" value="1"></el-option>
                                                <el-option label="共性问题" value="2"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="根治措施" class="h-elformWrap-1" prop="areaProblem" v-if="q.differenceType==2">
                                              <el-input  type="textarea" style="width: 450px;" :rows="1"  v-model="q.areaProblem" :show-overflow-tooltip="true"></el-input>
                                            </el-form-item>
                                            </div>
                                            <el-form-item label="到位时间" class="h-elformWrap-1" prop="inPlaceDate" v-if="q.differenceType==2" style="margin-left: 60px;margin-top: 8px">
                                              <el-date-picker
                                                  v-model="q.inPlaceDate"
                                                  :picker-options="pickerOptions"
                                                  type="date"
                                                  value-format="yyyy-MM-dd"
                                                  style="width: 250px;"
                                                  placeholder="选择日期">
                                              </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="解决进度" class="h-elformWrap-1" prop="measureProblem" v-if="q.differenceType==2" style="margin-top: 8px">
                                              <el-input  type="textarea" style="width: 450px;" :rows="1"  v-model="q.measureProblem" :show-overflow-tooltip="true"></el-input>
                                            </el-form-item>
                                          </el-form>
                                      </div>
                                    </div>

                                  <div class="replyBox"
                                       v-if="index1 == acIndex && item1.isLoop==0
                                         && ((userCode == item1.cucode && item1.count % 2 ==1)
                                         || (userCode == item1.jobUsercode && item1.count % 2 ==0))"
                                       v-for="(item1 , index1) in deptList" :key="index1+3">
                                    <div class="replyBar">
                                      <div class="tips">回复:</div>
                                      <textarea class="relpyInput" v-model="q.repContent"
                                                placeholder="请输入"></textarea>

                                      <el-button class="h-bgblueQ2" @click="xtHuifu(item1)">发送</el-button>
                                    </div>
                                  </div>
                                </div>
                                <div style="margin-top: 0.4rem;text-align: center;"
                                     v-if="index1 == acIndex" v-for="(item1 , index1) in deptList" :key="index1+4">
                                    <el-button class="h-btn h-bBtn h-bgblue"
                                               v-if="item1.isLoop==0 && (userCode == item1.cucode || gly)"
                                               @click="openBihuan(item1)">确认闭环
                                    </el-button>
                                    <el-button class="h-btn h-bBtn h-bgwhite" v-if="item1.isLoop==1">已确认闭环
                                    </el-button>
                                    <el-button
                                            size="small" class="h-btn  h-bgblueQ2"
                                            @click="genzongLiuch">
                                        跟踪审批
                                    </el-button>
                                    <!--查看跟踪审批流组件： showhistory：打开流程框，instid：流程id-->
                                    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="item1.instid"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="h-txtCenter h-mrt60">
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="backL">返回</el-button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import checkblue from '../../../assets/images/h-image-checkblue.png'
    import checkblueAc from '../../../assets/images/h-imgCheckBox-icon.png'
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                gly:false,
                id:null,
                showOrhide:false,
                status:1,
                toshow:"resource",
                checked:true,
                showhistory: false,
                red:false,
                euType: null,
                userCode: null,
                depCode: null,
                showQ: false,
                acIndex: '',
                isGx:'',
                relpyInput: '',
                imgcheck: {
                    checkblue, checkblueAc
                },
                zy:{
                    id:null,
                    instid:null,
                },
                q: {
                    id: null,
                    rddId: null,
                    repContent: null,
                    taskid: null,
                    requireTime:null,
                    areaProblem: null,
                    measureProblem: null,
                    inPlaceDate:null,
                    differenceType: null,
                    isGx:null,
                },
                //带线表单
                bh: {
                    areaCode: null,
                    channelCode: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                    cucode:null,
                    requireTime:null,
                    problemType:null,
                    problemTypeName:null,
                    problemDeptType:null,
                    problemDeptTypeName:null,
                },
                rddId: null,
                deptList: [],
                repList: [],
                instid: null,
                taskid: null,
                isCucode:false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                rules: {
                  differenceType: [{required: true, message: '请选择需求类型', trigger: 'change'}],
                  inPlaceDate: [{required: true, message: '请选择到位时间', trigger: 'blur'}],
                  areaProblem: [{required: true, message: '请填写根治措施', trigger: 'blur'}],
                  measureProblem: [{required: true, message: '请填写解决进度', trigger: 'blur'}],
                },
                requireDate:null,
            }
        },
        created() {
            this.showzhezhao();
            this.query();
            this.getFlag();
        },
        mounted() {
            this.query();
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/xuqiu/resourceList' && from.path == '/xuqiu/resources'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            genzongLiuch(){
                this.showhistory = true;
            },
            tabchange(i) {
                this.acIndex = i;
                console.log(i,this.deptList[i]);
                if(this.deptList[i].repList == null || this.deptList[i].repList.size <=0 || this.deptList[i].repList == ''){
                  this.q.areaProblem = '';
                  this.q.measureProblem = '';
                  this.q.inPlaceDate = '';
                  this.q.differenceType = this.bh.problemDeptType;
                  this.isGx = 0;
                }else {
                  this.q.areaProblem = this.deptList[i].repList[0].areaProblem;
                  this.q.measureProblem = this.deptList[i].repList[0].measureProblem;
                  this.q.inPlaceDate = this.deptList[i].repList[0].inPlaceDate;
                  this.q.differenceType = this.deptList[i].repList[0].differenceType;
                  this.isGx = 1;
                }
            },
            query() {
                this.gly = this.$store.getters.hasRole("swyl_xuqiugly,swyl_admin");
                this.userCode = this._user.usercode;
                // this.id = this.$route.query.id;
                if (this.$route.query.ywid) {
                    this.id = this.$route.query.ywid;
                } else if (this.$route.query.id) {
                    this.id = this.$route.query.id;
                }
                ss.xietongguanli.showXTzyBH(this.id).then(rd => {
                    this.bh = rd;
                    this.bh.euType = this.$getDictName("userCareType", rd.euType);
                    this.bh.areaCode = this.$getDictName("YLRegion", rd.areaCode);
                    this.deptList = rd.deptList;
                    this.bh.cucode = rd.cucode;
                    this.requireDate = rd.requireTime;
                    this.q.requireTime = rd.requireTime;
                    console.log(this.deptList[0].repList.length<=0)
                    console.log(this.deptList[0].repList)

                    if(this.deptList[0].repList.length<=0){
                      this.q.differenceType = rd.problemDeptType;
                      this.q.areaProblem = this.deptList[0].repList[0].areaProblem;
                      this.q.measureProblem = this.deptList[0].repList[0].measureProblem;
                      this.q.inPlaceDate = this.deptList[0].repList[0].inPlaceDate;
                      console.log(rd.problemDeptType)
                    }else {
                      console.log(222222222222222)
                      this.q.differenceType = this.deptList[0].repList[0].differenceType;
                      this.q.areaProblem = this.deptList[0].repList[0].areaProblem;
                      this.q.measureProblem = this.deptList[0].repList[0].measureProblem;
                      this.q.inPlaceDate = this.deptList[0].repList[0].inPlaceDate;
                    }
                    this.bh.problemDeptTypeName = rd.problemDeptTypeName;
                    this.bh.problemDeptType = rd.problemDeptType;
                    this.isGx = rd.deptList[0].isGx;
                    this.getFlag();
                    console.log("11111111111",this.deptList)
                    /*if(this.userCode != this.bh.cucode){
                        rd.deptList.forEach((item, index) => {
                            if (item.jobUsercode == this.userCode) {
                                this.deptList[0] = item;
                                return this.deptList;
                            }
                        })
                        if(this.deptList.length==0){
                            this.deptList = rd.deptList;
                        }
                    }else if (this.userCode == this.bh.cucode) {
                        this.deptList = rd.deptList;
                    }*/
                });
            },
            openBihuan(val) {
                this.zy.id = val.id;
                this.zy.instid = val.instid;
                console.log("123123123123");
                ss.xietongguanli.checkBhStatus(val.id).then(rd => {
                    if(rd.msg == "操作成功！"){
                        this.updateXtYes(val)
                    }else{
                        console.log("checkout",rd.msg);
                        this.$msg.confirm(rd.msg, () => {
                            ss.xietongguanli.updateXtYes(this.zy).then(rd => {
                                this.query();
                                this.$msg.alerts("闭环成功！",()=>{
                                    //刷新右上角的代办个数
                                    this.$store.dispatch("searchTasktotal")
                                })
                            });
                        })
                    }

                })
            },
            updateXtYes(val) {
                this.zy.id = val.id;
                this.zy.instid = val.instid;
                this.$msg.confirm("确认闭环?", () => {
                    ss.xietongguanli.updateXtYes(this.zy).then(rd => {
                        this.query();
                        this.$msg.alerts("闭环成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                        })
                    })
                })
            },
            xtHuifu(val) {
              var depflag = true;
                this.$refs['bh'].validate((valid) => {
                  if (valid) {
                    depflag = true;
                  } else {
                    this.$msg.msge("请完善答复问题后再提交！");
                    return false;
                  }
                });
                this.q.id = val.id;
                this.q.instid = this.instid;
                this.q.requireTime = this.requireDate;
                if(depflag){
                  ss.xietongguanli.xtHuifu(this.q).then(rd => {
                    this.query();
                    this.q.repContent = null;
                    this.$msg.alerts("回复成功！",()=>{
                      //刷新右上角的代办个数
                      this.$store.dispatch("searchTasktotal")
                      this.isGx = '1';
                    })
                  })
                }

            },
            backL() {
                this.$router.go(-1);
            },
            closeIt(){
                this.showOrhide = false;
                if(this.checked){
                    ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }else{
                    ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            nextStep(i){
                if(this.status ==1){
                    if(this.checked){
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }else{
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }
                }
            },
            getFlag(){
                console.log("isCucode123",this.isCucode);
                console.log("cucode",this.bh.cucode);
                console.log("userId",localStorage.getItem("userId"));
              if(localStorage.getItem("userId") == this.bh.cucode){
                    this.isCucode = true;
                    console.log("isCucode",this.isCucode);
              }
            },
          changDealer(value){

          }

        }
    }
</script>
<style scoped lang="scss">
    .y-container {
        width: 100%;

        .y_tabBar {
            display: flex;
            justify-content: flex-start;
            flex-wrap: nowrap;

            .eveBar {
                padding: 0.1rem 0.1rem 0.1rem 0.1rem;
                width: 1.85rem;
                height: 0.73rem;
                border: 1px solid #d9dfe9;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 0.16rem;
                position: relative;
                cursor: pointer;
                font-size: 0.18rem;
                color: #525252;

                &:last-child {
                    margin-right: 0;
                }

                .imgrigt {
                    margin-left: 0.08rem;
                }
            }

            .eveBarAc {
                background-color: #248bff;
                color: white;
            }

            .redCircle {
                width: 0.15rem;
                height: 0.15rem;
                background-color: #e64a19;
                position: absolute;
                top: -0.06rem;
                right: -0.06rem;
                border-radius: 50%;
            }
        }

        .containGrey {
            width: 100%;
            border: 1px solid #dedede;
            background-color: #f9f9f9;
            margin-top: 0.4rem;

            .containAll {
                padding: 0.3rem;
                max-height: 3.6rem;
                width: 100%;
                overflow-y: auto;
            }

            .dialogDiv {
                margin-bottom: 0.2rem;

                .timeTip {
                    color: #999999;
                    font-size: 0.14rem;
                    width: 100%;
                    text-align: center;
                    margin-bottom: 0.18rem;
                }

                .firstTalk {
                    display: flex;

                    .leftname {
                        font-size: 0.18rem;
                        color: #2a2a2a;
                    }

                    .containTalk {
                        font-size: 0.16rem;
                        color: #5e5e5e;
                        border: 1px solid #dedede;
                        background-color: white;
                        width: 7.1rem;
                        border-radius: 5px;
                        margin-left: 0.3rem;
                        padding: 0.2rem;
                        word-break: break-word;
                    }

                    .containTalk2 {
                        background-color: #e8e7e7;
                        margin-right: 0.3rem;
                        word-break: break-word;
                    }
                }

                .firstTalk2 {
                    flex-direction: row-reverse;
                }
            }

            .replyBox {
                padding: 0.2rem;
                border-top: 1px solid #dedede;
                display: flex;
                background-color: white;

                .tips {
                    font-size: 0.18rem;
                    color: #0072ed;
                    flex-shrink: 0;
                    margin-right: 0.15rem;
                }

                .replyBar {
                    position: relative;
                    width: 100%;

                    .relpyInput {
                        width: 100%;
                        height: 0.72rem;
                        border: none;
                        background-color: #FFFFFF;
                        outline: none;
                        padding: 0.08rem;
                        padding-top: 0.04rem;
                        resize: none;
                    }

                    .h-bgblueQ2 {
                        background-color: #2785e7;
                        color: white;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        height: 0.46rem;
                        width: 1.1rem;
                        padding: 0;
                    }
                }
            }
        }

    }

    .loopClosed {
        width: 100%;
        display: flex;
        padding-bottom: 50px;
    }

    .loopClosed .loop {
        width: 30%;
        margin-left: 3%;
    }

    .loopClosed .loop:first-child {
        margin: 0;
    }

    .loopClosed .loop .title {
        font-size: 0.18rem;
        color: #0e75e9;
        font-weight: bold;
        border-left: 0.05rem solid #0e75e9;
        margin-bottom: 0.3rem;
        padding-left: 10px;
    }

    .loopClosed .loop .boxs {
        width: 100%;
        padding: 60px;
        box-sizing: border-box;
        border: 1px solid #e4e4e4;
        color: #868686;
        font-size: 0.16rem;
        margin-bottom: 0.3rem;
        border-radius: 3px;
    }

    .shenglue {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .loopClosed .loop .buttons {
        width: 145px;
        height: 55px;
        border: 1px solid #e4e4e4;
        border-radius: 3px;
        color: #323232;
        font-size: 0.16rem;
        text-align: center;
        line-height: 55px;
        margin-left: 50%;
        transform: translateX(-72px);
        cursor: pointer;
    }
</style>
<style>

    .weekplandetail35 .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .weekplandetail35 .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .weekplandetail35 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail35 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }
</style>
<style scoped lang="scss">
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;
        }
        .steps{
            position: absolute;
            z-index: 1;
        }
        .step1{
            top: 0;
            left: 0;
        }

        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
      .el-textarea__inner{
        height: 26px;
        overflow-y: auto;
        /* overflow-y: auto;兼容ie  */
      }
    }
</style>
<style>

</style>
